import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Wordmark";
import { LogOut } from "lucide-react";

const NAV = [
  { to: "/hub", label: "Dashboard", end: true, testid: "hub-nav-dashboard" },
  { to: "/hub/deliverables", label: "Deliverables", testid: "hub-nav-deliverables" },
  { to: "/hub/packet", label: "Operating Room", testid: "hub-nav-packet" },
  { to: "/hub/events", label: "Events", testid: "hub-nav-events" },
  { to: "/hub/the-table", label: "The Table", testid: "hub-nav-table" },
  { to: "/hub/cohort", label: "Cohort materials", testid: "hub-nav-cohort" },
  { to: "/hub/account", label: "Account", testid: "hub-nav-account" },
];

export function HubLayout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <div data-testid="hub-layout" className="cv-ui-scope cv-container py-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-3">
          <p className="cv-kicker">The Hub</p>
          <p className="cv-body text-sm text-[#1F1B16]/70 mt-2">{user?.name || user?.email}</p>
          <nav className="mt-6 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `cv-sans uppercase tracking-[0.12em] text-xs py-2.5 border-l-2 pl-3 transition-colors ${
                    isActive
                      ? "border-[#A6633C] text-[#1F1B16]"
                      : "border-transparent text-[#1F1B16]/55 hover:text-[#1F1B16]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            {isAdmin && (
              <NavLink to="/admin" data-testid="hub-nav-admin" className="cv-sans uppercase tracking-[0.12em] text-xs py-2.5 border-l-2 border-transparent pl-3 text-[#515E4F] hover:text-[#1F1B16]">
                Admin panel
              </NavLink>
            )}
            <button data-testid="hub-logout-button" onClick={() => { logout(); navigate("/"); }} className="cv-sans uppercase tracking-[0.12em] text-xs py-2.5 pl-3 text-[#1F1B16]/55 hover:text-[#A65A43] inline-flex items-center gap-2 text-left">
              <LogOut size={13} /> Sign out
            </button>
          </nav>
        </aside>
        <main className="lg:col-span-9 min-h-[60vh]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
